import type { FaireProductEntity } from "../../entity_types/product";

export const p_e47s7ruprg: FaireProductEntity = {
  token: "p_e47s7ruprg",
  type: "product",
  name: "Mushroom Eye Socks",
  brandToken: "b_7a21757f",
  brandName: "Benjamin International",
  imageUrl:
    "https://cdn.faire.com/fastly/af4c435becdcbb4b2cf67fd5cfd61eb37190f8b2a206dd1e8e00a1e94d461ba6.jpeg",
  galleryImageUrls: [],
  priceDollars: 3.75,
  description:
    "All socks are carded.\nSocks with Benefits - 10% of the Profits will be donated to charity.\n• Women's size 9-11\n• Men's 7-12",
  tags: [],
  msrpDollars: 7.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:38.459Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
